import * as z from "zod";
import { Solana } from "../solana/solana-base";

export namespace CryptoMarket {
  export const ExchangeRateZ = z.object({
    price_usd: z.string(),
    volume_24h_usd: z.string(),
    market_cap_usd: z.string(),
    price_percent_change_24h: z.string(),
  });
  export type ExchangeRate = z.infer<typeof ExchangeRateZ>;

  export const EXCHANGE_RATE_SOL_ID = "SOL";
  export const SOL_COIN_MARKET_CAP_ID = 5426;

  export type ChartPoint = {
    time: string;
    value: number; // This is the price
    price: number; // This is in dollars (not cents)
    volume_24h: number;
    market_cap: number;
  };

  export enum ChartPeriod {
    LastHour = "last-hour",
    LastDay = "last-day",
    LastWeek = "last-week",
    LastMonth = "last-month",
    Last3Months = "last-3-months",
  }
}

export type CryptoGetApi = {
  "/crypto/get-market-charts": {
    request:
      | {
          mint_address: Solana.Address;
        }
      | {
          symbol: string; // DEPRECATED
        }
      | {
          coin_id: string; // DEPRECATED
        };
    response: {
      period_to_chart: Record<
        CryptoMarket.ChartPeriod,
        Array<CryptoMarket.ChartPoint>
      >;
      stats: {
        high_3m_usd: number;
        low_3m_usd: number;
        high_24h_usd: number;
        low_24h_usd: number;
      };
    };
  };
};

export type CryptoPostApi = {
  "/moonpay/get-buy-url": {
    request: {
      sol_amount?: number;
      email?: string;
      wallet_address: string | null;
      redirect_url?: string;
    };
    response: { url: string };
  };
  "/moonpay/webhook": {
    request: any;
    response: {};
  };
};
